var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulerHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M592 128H48C21.6 128 0 149.6 0 176V336C0 362.4 21.6 384 48 384H592C618.4 384 640 362.4 640 336V176C640 149.6 618.4 128 592 128ZM592 336H48V176H112V224C112 232.8 119.2 240 128 240H128C136.8 240 144 232.8 144 224V176H208V224C208 232.8 215.2 240 224 240H224C232.8 240 240 232.8 240 224V176H304V224C304 232.8 311.2 240 320 240H320C328.8 240 336 232.8 336 224V176H400V224C400 232.8 407.2 240 416 240H416C424.8 240 432 232.8 432 224V176H496V224C496 232.8 503.2 240 512 240H512C520.8 240 528 232.8 528 224V176H592V336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerHorizontal);
export default __webpack_public_path__ + "static/media/ruler-horizontal.712fb1987c67be7f443be26f56385b5e.svg";
export { ForwardRef as ReactComponent };